import AlphaHelpers from '../abstracts/classes/alpha-helpers'

document.addEventListener('DOMContentLoaded', () => {
  // iOS needs double tap on links when WP Rocket "Delay JS execution" feature is enabled
  // fix it by triggering a manual click on links
  // @see https://github.com/wp-media/wp-rocket/issues/3142
  if (AlphaHelpers.iOS()) {
    let isMoving = false
    let movingTimeoutId = null
    const clickTimeout = 50

    window.addEventListener('touchmove', () => {
      isMoving = true
      clearTimeout(movingTimeoutId)
      movingTimeoutId = setTimeout(() => {
        isMoving = false
      }, clickTimeout)
    })

    window.addEventListener('touchend', (e) => {
      const targetEl = e.target || null
      if (targetEl) {
        const interactAttributes = ['href', 'data-oblink-href']
        for (const attrName of interactAttributes) {
          // skip clicks while moving
          const clickableEl = targetEl.closest(`[${attrName}]`)
          if (clickableEl && !isMoving) {
            e.preventDefault()
            e.stopPropagation()

            // manually trigger click on element after a small delay
            setTimeout(() => clickableEl.click(), clickTimeout)
            break
          }
        }
      }
    })
  }
})
